import { render, staticRenderFns } from "./AIGeneratedTextIcon.vue?vue&type=template&id=87c1fa52&scoped=true"
import script from "./AIGeneratedTextIcon.vue?vue&type=script&lang=js"
export * from "./AIGeneratedTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1fa52",
  null
  
)

export default component.exports